export default __webpack_public_path__ + "static/media/campaign.9b2e5b78.svg";